import Snowfall from 'react-snowfall';
import AppPanel from './AppPanel.js';
import { LogoContainer, Background } from './WhiteElephantPanel.styles.js';

export default function WhiteElephantPanel() {
    return (
        <a
            href="https://white-elephant-game.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'block', width: '100%', height: '100%' }}
        >
            <AppPanel title={"WHITE ELEPHANT"} releaseDate={"DEC '24"}>
                <LogoContainer>
                    <Background>
                        <Snowfall />
                    </Background>
                    <h1><em>presence</em></h1>
                </LogoContainer>
            </AppPanel>
        </a>
    );
}
